






















import Vue from "vue";
import DocumentToolbarMenuButton from "@/components/modules/document/toolbar/DocumentToolbarMenuButton.vue";
import ApproveDocumentReviewAction from "@/components/modules/document/toolbar/actions/ApproveDocumentReviewAction.vue";
import RejectDocumentReviewAction from "@/components/modules/document/toolbar/actions/RejectDocumentReviewAction.vue";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
import { DocumentAnchor } from "@infoland/iprova-api";
import { DocumentReviewer } from "@/types/document/documentReviewer";
export default Vue.extend({
    name: "MenuDocumentReviewAction",
    components: { DocumentToolbarMenuButton, ApproveDocumentReviewAction, RejectDocumentReviewAction },
    props: {
        documentProperties: Object as () => DocumentVersionInfo,
        isDocumentReady: Boolean,
        commentSubjectSelections: Array as () => DocumentAnchor[],
        reviewer: Object as () => DocumentReviewer
    }
});
